module.exports = __webpack_public_path__ + "img/hiraya-mnl.ec86d5c0.png";